<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col-md-4 left">
          <div class="title">
            {{ $t('sidebar.configuration') }} > {{ $t('sidebar.notifications') }}
          </div>
        </div>
      </div>
    </div>
    <div class="content col-md-12">
      <channel-notification
        :app_id="3"
        :code="['300']"/>
    </div>
    <BaseModalOverLimit
      :id="modalFeeAlert"
      :headerText="$t('overlimit.linemessage.header')"
      :bodyTextUnitPrice="$t('overlimit.linemessage.body.unitprice', { number: getCurrencyWithNumber(numberel(pricing.messageLine, '0,0.[000000]')) })"
      :bodyTextPerMonth="$t('overlimit.linemessage.body.permonth', { number: numberel(shopUseLimit.messageLine, '0,0') })"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import ChannelNotification from '@/components/custom/ChannelNotification.vue'
import sidebarModule from './../../sidebarModule'
import submenuModule from '../submenuModule'
import _ from 'lodash'

export default {
  name: 'PosConfigurationNotification',
  components: {
    ChannelNotification,
  },
  data () {
    return {
      modalFeeAlert: 'modalFeeAlert',
    }
  },
  computed: {
    ...mapGetters({
      warehouses: 'getWarehouses',
      sidebar: 'getSidebar',
      shopUseLimit: 'getShopUseLimit',
    }),
    ...mapState('treesoft', {
      pricing: 'pricing',
    }),
  },
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
    },
    warehouses: function (newVal, oldVal) {
      sidebarModule.init(_.cloneDeep(require('../sidebar.json')))
      sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
      sidebarModule.active({
        sidebarAtIdx: 9,
        submenuAtIdx: 3,
      })

      // set ready
      this.ready = true
    },
  },
  async mounted () {
    await this.fetchData()
    $(`#${this.modalFeeAlert}`).modal('show')
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.inventory.title'),
      current: {
        app_name: 'inventory',
        app_id: 3,
        module_id: 10,
      },
    })
    // set sidebar stockcontrols ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
    sidebarModule.active({
      sidebarAtIdx: 9,
      submenuAtIdx: 3,
    })
  },
  methods: {
    ...mapActions([
      'getShopUseLimit',
    ]),
    ...mapActions('treesoft', {
      getPricing: 'getPricing',
    }),
    async fetchData () {
      this.ready = false
      await Promise.all([
        this.$store.dispatch('getWarehouses'),
        this.getShopUseLimit(),
        this.getPricing(),
      ])
      this.ready = true
      this.showFinish(this.$Progress)
    },
  },
  destroyed: function () {
    this.leavePage(this.$Progress, [])
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/inventory/configuration/Notification.vue